import { cva } from 'class-variance-authority';

/**
 * Represents the style configuration for a GlowButton component.
 */
export const buttonStyle = cva(
    [
        'flex justify-center items-center',
        'rounded-0.5 whitespace-nowrap flex-nowrap',
        'duration-slow1 border border-solid',
        'gap-0.25',
    ],
    {
        variants: {
            fontSize: {
                body: 'text-body',
                bodySmall: 'text-bodySmall',
            },
            variant: {
                primary: [
                    'text-text-primary-inverse fill-text-primary-inverse',
                    'bg-surface-brand hover:bg-surface-brand-hover active:bg-surface-brand-pressed',
                    'border-surface-brand hover:border-surface-brand-hover active:border-surface-brand-pressed border-bold',
                ],
                secondary: [
                    'text-text-primary fill-text-primary',
                    'bg-surface-primary hover:bg-surface-primary-hover active:bg-surface-primary-pressed',
                    'border-border-brand border-bold',
                ],
                tertiary: [
                    'text-text-primary fill-text-primary',
                    'bg-surface-primary hover:bg-surface-primary-hover active:bg-surface-primary-pressed',
                    'border-border-primary border-medium',
                ],
                onElement: [
                    'text-text-primary fill-text-primary',
                    'bg-surface-primary hover:bg-surface-primary-hover active:bg-surface-primary-pressed',
                    'border-none',
                ],
            },
            width: {
                auto: 'w-auto',
                full: 'w-full',
                fit: 'w-fit',
                responsive: 'w-full tablet:w-fit',
            },
            size: {
                large: 'px-1.125 py-0.625',
                medium: 'px-0.625 py-0.375',
                small: 'px-0.625 py-0.25',
            },
            fontFamily: {
                arial: 'font-arial',
                brand: 'font-brand',
            },
        },
        defaultVariants: {
            variant: 'primary',
            size: 'large',
            fontFamily: 'brand',
            width: 'auto',
        },
    },
);
